import { createTheme } from '@mui/material/styles';


export const appTheme = createTheme({
    palette: {

    },
});